export default __webpack_public_path__ + "static/ks-4c56fe14f42e0af9f0e7ae961e418c37.png";